import { Flow } from "../types/IFlow";
import {
  SingleMedicalStepDefaultNavigatorConfiguration,
  SingleMedicalStepPreQualifiedPatientNavigatorConfiguration
} from "./NavigatorConfigurations";
import {
  experimentalScreeningStepConfigurations,
  noConfirmationCenterSelectableBookingStepConfigurations
} from "./StepConfigurations";

const singleMedicalStepNoBookFlowName = "SingleMedicalStepNoBookFlow";

/** The treatment flow where a no-book guest experiences the single-page medical presentation. */
class SingleMedicalStepNoBookFlow extends Flow {
  static readonly flowName = singleMedicalStepNoBookFlowName;
  readonly name = singleMedicalStepNoBookFlowName;
  readonly steps = {
    ...experimentalScreeningStepConfigurations,
    ...noConfirmationCenterSelectableBookingStepConfigurations
  };
  readonly navigatorItems = SingleMedicalStepDefaultNavigatorConfiguration;
  isDisqualificationPossible() {
    return true;
  }
}

/** The treatment flow for pre-qualified no-book guests (scheduling-only path). */
export class PreQualifiedSingleMedicalStepNoBookFlow extends Flow {
  readonly name = singleMedicalStepNoBookFlowName;
  readonly steps = { ...noConfirmationCenterSelectableBookingStepConfigurations };
  readonly navigatorItems = SingleMedicalStepPreQualifiedPatientNavigatorConfiguration;
  isDisqualificationPossible() {
    return false;
  }
}

export default SingleMedicalStepNoBookFlow;
